/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"IndexPage":"IndexPage_6xgGU","container":"container_-NDNO","consultation":"consultation_Jg7r8"};